import { ResearchTopicTemplate } from "~/types/app";

export const resolveResearchTopicTemplate = (
  value: unknown
): ResearchTopicTemplate => {
  const normalized =
    typeof value === "string" ? value.trim().toLowerCase() : "";

  return normalized === ResearchTopicTemplate.V2
    ? ResearchTopicTemplate.V2
    : ResearchTopicTemplate.V1;
};
